import { QuestionBase } from './question-base';

/*

Sample:

new TextboxQuestion({
  key: 'name',
  label: 'nouns.name',
  // value: 'Peter',
  required: true,
  order: 1
}),

*/
export class NumberQuestion extends QuestionBase<number> {
  controlType = 'number';
  type = 'number';

  constructor(options: {} = {}) {
    super(options);
    // this.type = options['type'] || 'text';
  }
}
